export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_BRANDS':
      return {
        ...state,
        brands: action.payload.data,
      }
    case 'GET_BRAND':
      return {
        ...state,
        brand: action.payload.data,
      }
    default:
      return state
  }
}
